import React from 'react';

import { Skeleton } from '@repo/ui/components/ui/skeleton';

export const TabsSectionSkeleton: React.FC = () => {
  return (
    <div className="flex w-full flex-col gap-2 px-3">
      <Skeleton className="h-4.5 w-full rounded-md bg-[#2D3748]" />
      <div className="space-y-2">
        <Skeleton className="h-11.75 w-full rounded-md bg-[#2D3748]" />
        <Skeleton className="h-11.75 w-full rounded-md bg-[#2D3748]" />
        <Skeleton className="h-11.75 w-full rounded-md bg-[#2D3748]" />
      </div>
    </div>
  );
};
